/**
 * inCust API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface TourCardAccountApiModel {
  /**
   * Account amount
   */
  amount?: number;
  /**
   * Account ID
   */
  id?: string;
  /**
   * Account precision
   */
  precision?: TourCardAccountApiModelPrecisionEnum;
  /**
   * public title
   */
  public_title?: string;
}
export enum TourCardAccountApiModelPrecisionEnum {
  Integer = 'integer',
  TwoDecimalPlaces = 'two-decimal-places',
  ThreeDecimalPlaces = 'three-decimal-places'
}
